import { render } from "./NavDrawer.vue?vue&type=template&id=5016a719&scoped=true"
import script from "./NavDrawer.vue?vue&type=script&lang=js"
export * from "./NavDrawer.vue?vue&type=script&lang=js"

import "./NavDrawer.vue?vue&type=style&index=0&id=5016a719&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5016a719"]])

export default __exports__